<template>
    <div>
        <Select placeholder="请输入中文名称进行搜索" :values="value" ref="selectRef" multiple :max-tag-count="1" :loading="loading" @on-change="handleChangeOption" filterable @on-query-change="handleChangeQuery">
            <Tree v-if="!loading&&data.length" :data="data" multiple @on-check-change="handleChange" show-checkbox check-directly :render="renderContent"></Tree>
            <!-- <div v-else-if="loading" style="text-align: center;">加载中...</div> -->
            <div v-else style="text-align: center;">暂无短剧</div>
        </Select>
    </div>
</template>

<script>
import { getPrimaryPlays } from '@/api/play'
import { cloneDeep } from 'lodash';
export default {
    props: {
        value: {
            type: Array,
            default: ()=>[]
        },
        langId: {
            type: String,
            default: null
        }
    },
    data(){
        return {
            data: [],
            treeValue: [],
            loading: false,
            query: ''
        }
    },
    model: {
        prop: 'value',
        event: 'update:value'
    },
    watch:{
        value(){
            this.handleChange(this.value)
        },
        query(){
            this.handleGetPlay(this.query)
        }
    },
    methods: {
        renderContent(h,{root,node,data}){
            return <div>
                    {data.langName&&
                        <div style={{display:'inline-block',width:'4rem',textAlign:'center',padding:'3px',color:'#fff',background:data.langColor,borderRadius: '90px',marginRight: '10px'}}>
                            {data.langName}
                        </div>}
                    {data.title}
                </div>
        },
        handleChangeQuery(e){
            this.$refs.selectRef.filterQueryChange = false
            this.$refs.selectRef.query = ''
            this.$refs.selectRef.$el.querySelector('.ivu-select-input').oninput=(a)=>{
                if(a.inputType=='deleteContentBackward'&&!a.target.value){
                    this.query = ''
                }
            }
            this.$refs.selectRef.$el.querySelector('.ivu-select-input').value = e
            if(e){
                this.query = e
            }
        },
        handleChangeOption(e){
            this.treeValue = e
            this.data = cloneDeep(this.data.map(i=>{
                if(i.children.find(j=> !e.includes(j.value))){
                    i.checked = false
                }
                return {
                    ...i,
                    children: cloneDeep(i.children.map(j=>{
                        return {
                            ...j,
                            checked: e.includes(j.value)
                        }
                    }))
                }
            }))
            this.$refs.selectRef.$el.querySelector('.ivu-select-input').focus()
            this.query = ''
            this.$emit('update:value',e)
        },
        handleChange(e,node){
            console.log(node);
            if(!node) return
            const v = []
            e.map(i=>{
                if(i.children)i.children.map(j=>{
                    v.push({
                        label: j.title,
                        value: j.value
                    })
                })
            })
            this.treeValue = e
            if (node && node.children) {
                if (!node.checked)
                    node.children.map(i => {
                        if (this.$refs.selectRef.values.map(i=>i.value).includes(i.value)) {
                            this.$refs.selectRef.onOptionClick({
                                label: i.title,
                                value: i.value
                            })
                        }
                    })
                else {
                    node.children.map(i => {
                        if (!this.$refs.selectRef.values.map(i=>i.value).includes(i.value)) {
                            this.$refs.selectRef.onOptionClick({
                                label: i.title,
                                value: i.value
                            })
                        }
                    })
                }
                return
            }
            if (node&&!node.parent)
                this.$refs.selectRef.onOptionClick({
                    label: node.title,
                    value: node.value
                })
            // this.$refs.selectRef.values = v
        },
        handleGetPlay(playName){
            if(!playName) return
            this.loading = true
            getPrimaryPlays({
                playName,
                langId: this.langId
            }).then(r=>{
                this.data = r.data.map(i=>{
                    return {
                        title: i.parentPlayName,
                        expand: true,
                        parent: true,
                        value: i.parentPlayId,
                        children: i.plays.map(j=>{
                            return {
                                value: j.id,
                                langColor: j.langColor,
                                title: j.playName,
                                checked: this.treeValue.includes(j.id),
                                expand: true,
                                langName: j.langName
                            }
                        })
                    }
                })
                this.loading = false
            })
        },
        /* 清空选中项 */
        handleReset(){
            // 清空选中值
            this.treeValue = []
            // 清空树形数据中所有节点的选中状态
            this.data = this.data.map(item => {
                return {
                    ...item,
                    checked: false,
                    children: item.children.map(child => {
                        return {
                            ...child,
                            checked: false
                        }
                    })
                }
            })
            // 清空 Select 组件中的选中项
            if (this.$refs.selectRef) {
                this.$refs.selectRef.values = []
            }
            // 触发更新事件
            this.$emit('update:value', [])
            // 清空搜索查询
            this.query = ''
        }
    },
}
</script>

<style lang="less" scoped>
/deep/.ivu-tree-children{
    width: 100%;
    &>li{
        
        &>.ivu-tree-children{
            &>li{
display:flex;
        align-items: center;
        // flex-wrap: wrap;
            }
        }
    }
}
</style>
